  <template>
  <div>
   <b-modal style="padding:15px" size="lg" id="AddFlourTypeModal" ref="modal" title="Add Flour Type" ok-title="Submit" cancel-title="Close" 
      @hidden= "resetModal()" @ok= "handleOk" :ok-disabled = "this.$refs.AddFlourTypeForm != undefined ? !this.$refs.AddFlourTypeForm.checkValidity() : true">
        <form ref="AddFlourTypeForm" @submit.stop.prevent= "handleSubmit">
          <div class="row">
           
            <div class="col-md-6">
               <b-form-group  label="Name" label-for="type-input" autocomplete="off">
                <b-form-input id="type-input" v-model= "TypeName"  required></b-form-input>
              </b-form-group>
            </div>
             <div class="col-md-6">
              <b-form-group label="Flour Type">
                <b-form-radio-group
                  v-model="BaseType"
                  :options="BaseTypes"
                  name="radio-inline"
                ></b-form-radio-group>
              </b-form-group>
            </div>
          </div>     
        </form>
      </b-modal>
      <Toaster ref= "toaster"/>
      </div>
      </template>

      <script>
import axios from 'axios';
// import config from '../config.js';
import Toaster from '../../toaster'

export default {
    name: 'AddFlourType',
    data(){
        return{
          moduleName:'Add Flour Type',   
          TypeName:'',
          BaseType:1,
          CompanyId:null,
          BaseTypes: [
            { text: 'Govt',  value: 1 },
            { text: 'Other',  value: 2 },
          ],
		}
  },
  components:{
    Toaster,
  },



methods:{
  
   addWheatType(){ 
        
     axios.post('/flourtype/Add', 
      {"TypeName":this.TypeName, "CompanyId":this.$auth.user().companyId,"BaseType":Number(this.BaseType)
      })
      .then(res=>{
            if(res.data.status == 1)
            {
               
                 this.$refs.toaster.showToast('Sucess','success','Flour Type has been added successfully!')
                  this.$bvModal.hide('AddFlourTypeModal')
                  this.$parent.getFlourTypes();  
            }
            else if(res.data.status == -1)
            {
                this.$refs.toaster.showToast('Error','error',res.data.msg)
             
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
    },

   checkFormValidity() {
        const valid = this.$refs.AddFlourTypeForm.checkValidity()
        // this.usernameState = valid
        return valid
      },
     
      resetModal() {
        this.TypeName = '';  
      },
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },
      handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return
        } 
        this.addWheatType()
       
      },

 

  }
	

}
</script>
